module.exports = __webpack_public_path__ + "img/cap.73760353.svg";